import { ExclamationCircleOutlined } from '@ant-design/icons';
import styled from 'types/theme.types';
import type { ReactNode } from 'react';
import Tooltip from 'components/common/bridged-tooltip';

export const Warning: React.FC<{ content: ReactNode }> = ({ content }) => {
  return (
    <Tooltip title={content}>
      <StyledExclamationCircleOutlined />
    </Tooltip>
  );
};

const StyledExclamationCircleOutlined = styled(ExclamationCircleOutlined)`
  color: var(--icon-warning);
`;
